import { Component, OnInit } from '@angular/core'
import { AuthService } from '../services/auth.services'
import { RestServices } from '../services/rest.services'
import { FormBuilder } from '@angular/forms'
import { SharedServices } from '../services/shared.services'
import { CookieService } from 'ngx-cookie-service'
import { Router } from '@angular/router'

@Component({
    selector: 'app-submenubox',
    templateUrl: './submenubox.component.html',
    styleUrls: [
        '../app_manager/app_element/status/status.component.css',
        '../stagingcss/root-ui-view.component.css',
        '../stagingcss/main-body.component.css',
        '../stagingcss/main-view.component.css',
        '../stagingcss/lui-select.component.css',
    ],
})

export class SubmenuboxComponent implements OnInit {
    fullScreenActive = ''
    presentationModeClass = ''
    hiddenModal = 'hidden'
    // presentationModeValue = false;
    presentationModeValue = localStorage.getItem('presentationModeValue') === 'true' ? true : false
    msExitFullscreen: any
    mozCancelFullScreen: any

    constructor(private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private _sharedService: SharedServices,
                private router: Router, 
                private cookieService: CookieService,) {


        if (this.presentationModeValue === true) {
            this.presentationModeClass = 'fullScreenActive'
        } else {
            this.presentationModeClass = ''
        }
    }


    // show modal language
    selectLanguage() {
        var selectLanguage: string = 'selectLanguage'
        this._sharedService.emitChange(selectLanguage)
    }

    goInFullscreen() {
        interface FsDocumentElement extends HTMLElement {
            msRequestFullscreen?: () => void;
            mozRequestFullScreen?: () => void;
        }

        var element = document.body
        const fsDocElem = <FsDocumentElement>document.body
        if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen()
        } else if (fsDocElem.mozRequestFullScreen) {
            fsDocElem.mozRequestFullScreen()
        } else if (fsDocElem.msRequestFullscreen) {
            fsDocElem.msRequestFullscreen()
        }

        this.fullScreenActive = 'fullScreenActive'
    }

    goOutFullscreen() {
        interface FsDocument extends HTMLDocument {
            mozFullScreenElement?: Element;
            msFullscreenElement?: Element;
            msExitFullscreen?: () => void;
            mozCancelFullScreen?: () => void;
        }

        const fsDoc = <FsDocument>document
        if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen()
        } else if (fsDoc.mozCancelFullScreen) {
            fsDoc.mozCancelFullScreen()
        } else if (fsDoc.msExitFullscreen) {
            fsDoc.msExitFullscreen()
        }
        this.fullScreenActive = ''
    }

    fullScreen() {
        if (this.fullScreenActive === 'fullScreenActive') {
            this.goOutFullscreen()
        } else {
            this.goInFullscreen()
        }
    }

    presentationMode() {
        if (this.authData.getItem('user')) {
            const user = JSON.parse(this.authData.getItem('user'));
            const expires = parseInt((user.expiresInSeconds)) * 1000;
            const timeOut = parseInt(this.authData.getItem('timeout')) + expires;
            const timeNow = Date.now();
            if(timeOut <= timeNow){
                localStorage.removeItem('user')
                localStorage.removeItem('token')
                localStorage.removeItem('timeout')
                this.cookieService.delete('token')
                jQuery('body').attr('class', 'blue')
                localStorage.removeItem('urlLogo')
                localStorage.removeItem('classThemeBody')
                return this.router.navigateByUrl('/app/login')
            }
        }
        if (this.presentationModeClass === 'fullScreenActive') {
            this.presentationModeClass = ''
        } else {
            this.presentationModeClass = 'fullScreenActive'
        }
        this.presentationModeValue = !this.presentationModeValue
        localStorage.setItem('presentationModeValue', this.presentationModeValue.toString())
        this._sharedService.emitChange(this.presentationModeValue)
        const arraySearchPresentationMode = ['arraySearchPresentationMode-selectData', this.presentationModeValue]
        this._sharedService.emitChangePresentationModeSearchData(arraySearchPresentationMode)
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/submenubox/submenubox.component.ts